import request from '@/utils/request'

// 自定义表单

let CustomApi = {

    /*列表*/
    getList(data, errorback) {
        return request._post('/shop/study.custom/index', data, errorback);
    },

    /*删除*/
    del(data, errorback) {
        return request._post('/shop/study.custom/del', data, errorback);
    },

}

export default CustomApi;



// WEBPACK FOOTER //
// ./src/api/study/custom.js